import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Man from "./pages/Man";
import Woman from "./pages/Woman";
import Home from "./pages/Home";

import ResultPage from "./pages/ResultPage";
import Apply from "./pages/Apply";
import SharePage from "./pages/SharePage";

const home = {
  path: "/",
  index: true,
  element: <Home />,
};
const man = {
  path: "man",
  element: <Man />,
};
const woman = {
  path: "woman",
  element: <Woman />,
};

const apply = {
  path: "apply",
  element: <Apply />,
};

const routerConfig = [
  {
    element: <App />,
    children: [
      home,
      man,
      woman,
      apply,
      {
        element: <ResultPage />,
        path: "result",
      },
      {
        element: <SharePage />,
        path: "share",
      },
    ],
  },
];

export const Routers = createBrowserRouter(routerConfig, {
  basename: "/worldcup",
});
